import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import warehouseImage from '../../_contentnew/about.webp'

const AboutSection = () => {
  const navigate = useNavigate()

  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
    <Box
      sx={{
        py: { xs: 2, sm: 8 },
        backgroundColor: '#2B2930',
      }}
    >
      <Box
        width="80%"
        maxWidth="1200px"
        mx="auto"
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column-reverse',
            md: 'row',
          },
          alignItems: 'center',
          gap: 6,
        }}
      >
        {/* Image */}

        <Box
          width={{ xs: 1, md: 0.5 }}
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box
            component="img"
            src={warehouseImage}
            alt="Pulse Pallets"
            sx={{
              width: '100%',
              maxHeight: '450px',
              objectFit: 'cover',
              borderRadius: '12px',
              mb: { xs: 6, sm: 0 }
            }}
          />
        </Box>

        {/* Content */}

        <Box
          width={{ xs: 1, md: 0.5 }}
          sx={{ textAlign: {xs: 'center', md: 'left' } }}
        >
          <Typography
            variant="h4"
            sx={{
              color: '#fff',
              fontWeight: 700,
              mb: 3,
              fontSize: {
                xs: '2rem',
                md: '2.5rem',
              },
            }}
          >
            Built From The Ground Up
          </Typography>

          <Typography
            sx={{
              color: '#d7e3dd',
              lineHeight: 1.8,
              mb: 3,
            }}
          >
            Founded by Freddy Byrne-Stevens in 2025, Pulse Pallets started with a
            single 3.5 tonne truck and a determination to build something great.
            Based near Basingstoke, Hampshire, we're focused on supplying high quality pallets
            while reducing waste through repair, reuse and recycling.
          </Typography>

          <Typography
            sx={{
              color: '#d7e3dd',
              lineHeight: 1.8,
              mb: 4,
            }}
          >
            What began as a one-man mobile operation has grown into a trusted
            pallet supplier serving businesses across Hampshire and the
            surrounding areas. We pride ourselves on personal service,
            competitive pricing and doing things properly from first enquiry
            through to delivery.
          </Typography>

          <Button
            size="large"
            onClick={() => navigateLink('/about')}
            sx={{
              backgroundColor: '#0A9B48',
              color: '#fff',
              minWidth: '220px',
              py: 2,
              px: 4,
              fontSize: '1rem',
              fontWeight: 700,
              letterSpacing: '1px',
              borderRadius: 0,
              transition: 'all 0.3s ease',

              '&:hover': {
                transform: 'translateY(-4px)',
                borderColor: '#fff',
                border: '1px solid',
                boxShadow: '0 10px 30px rgba(87,200,77,0.15)',
                backgroundColor: '#57C84D',
              },
            }}
          >
            LEARN MORE →
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default AboutSection